export default (node) => {
  /**
   * Data + elements
   */
  const buttonVideo = node.querySelector('[data-play-button-container]');
  const buttonVideoOutside = node.querySelector('[data-button-video-outside]');

  /**
   * Functions
   */
  const openVideo = () => {
    const event = new CustomEvent('modal-video:open', {
      detail: node.querySelector('[data-video-container]'),
    });
    document.dispatchEvent(event);
  };

  /**
   * Init
   */
  const init = () => {
    if (buttonVideo) {
      buttonVideo.addEventListener('click', openVideo);
    }
    if (buttonVideoOutside) {
      buttonVideoOutside.addEventListener('click', openVideo);
    }
  };

  init();
};
